export const mtuKeys = {
  get: (
    workOrderOperationId?: string | null,
    instanceId?: string | null,
    machineNId?: string | null
  ) => ["mtus", workOrderOperationId, instanceId, machineNId] as const,
  getStatuses: () => ["mtuStatuses"] as const,
};
